import { useEffect } from "react";

export const useSEO = ({ title, description, image, url }) => {
  useEffect(() => {
    // Mise à jour du titre de la page
    if (title) {
      document.title = `${title} - Alpha Mares`;
    }

    // Fonction pour créer ou mettre à jour une balise meta
    const updateMetaTag = (property, content) => {
      if (!content) return;

      let element =
        document.querySelector(`meta[property="${property}"]`) ||
        document.querySelector(`meta[name="${property}"]`);

      if (element) {
        element.setAttribute("content", content);
      } else {
        element = document.createElement("meta");
        element.setAttribute("property", property);
        element.setAttribute("content", content);
        document.getElementsByTagName("head")[0].appendChild(element);
      }
    };

    // Métadonnées Open Graph pour Facebook
    updateMetaTag("og:title", title);
    updateMetaTag("og:description", description);
    updateMetaTag("og:image", image);
    updateMetaTag("og:url", url);
    updateMetaTag("og:type", "website");
    updateMetaTag("og:site_name", "Alpha Mares");

    // Métadonnées Twitter Card
    updateMetaTag("twitter:card", "summary_large_image");
    updateMetaTag("twitter:title", title);
    updateMetaTag("twitter:description", description);
    updateMetaTag("twitter:image", image);

    // Métadonnée description standard
    updateMetaTag("description", description);

    // Cleanup function pour restaurer les valeurs par défaut
    return () => {
      document.title = "Alpha Mares";
      updateMetaTag("description", "Alpha Mares website");
    };
  }, [title, description, image, url]);
};

export default useSEO;
